/** 能源 — 设备用水 /energy/charging-water（equipmentWater.vue） */
export default {
  equipmentWater: {
    filterStatPeriod: '统计时间',
    phDateStart: '开始时间',
    phDateEnd: '结束时间',
    filterWater: '选择水表',
    phWater: '请选择水表',
    exportLoading: '导出中...',
    exportReport: '导出报表',
    loadingText: '数据加载中...',
    sectionTitle: '水表用水',
    sectionTip: '请选择水表查看详细数据',
    colWaterId: '水表ID',
    colWaterName: '水表名称',
    colSerial: '设备序列号',
    colBindType: '绑定类型',
    colBindInfo: '绑定信息',
    colOccurDate: '用水日期',
    colWaterFee: '用水费(元)',
    colWaterVolume: '用水量(吨)',
    colStartRead: '起始读数',
    colEndRead: '截止读数',
    colTime: '时间',
    colRead: '读数',
    emptyNoData: '暂无数据',
    emptyTip: '请选择水表后查看数据',
    pickerLast7: '最近7天',
    pickerLast15: '最近15天',
    pickerLast30: '最近30天',
    pickerThisMonth: '本月',
    pickerLastMonth: '上月',
    msgWaterListFail: '获取水表列表失败',
    msgPickPeriod: '请选择统计时间',
    msgPickWater: '请选择水表',
    msgNoData: '未查询到数据',
    msgFetchFail: '获取数据失败',
    msgDateMax31: '日期最多只能选择31天',
    msgExportEmpty: '暂无数据可导出',
    msgExportOk: '导出成功！',
    msgExportFail: '导出失败',
    msgExportRetry: '请重试',
    exportFilterLine: '统计时间: {start} 至 {end}  |  水表: {water}',
    bindType1: '专用表',
    bindType2: '公摊表',
    bindType3: '公式表',
    settleWay1: '系统结算',
    settleWay2: '手动结算',
    exportSheetName: '水表用水报表',
    exportFilePrefix: '水表用水报表',
    expColWaterId: '水表ID',
    expColWaterName: '水表名称',
    expColSerial: '设备序列号',
    expColBindType: '绑定类型',
    expColBindInfo: '绑定信息',
    expColOccurDate: '用水日期',
    expColSettleWay: '结算方式',
    expColWaterFee: '用水费(元)',
    expColWaterVolume: '用水量(吨)',
    expColStartRead: '起始读数',
    expColEndRead: '截止读数',
    expColTime: '时间',
    expColRead: '读数'
  }
}
